export default {"src":"/_next/static/media/error-circle-fill.6e6660c9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};